"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackRegularPaymentMethodSelected = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
const checkoutPaymentMethodEventLabelMap = {
    [enums_1.PaymentMethod.Invoice]: 'Invoice',
    [enums_1.PaymentMethod.PayPal]: 'Paypal',
    [enums_1.PaymentMethod.StripeCreditCard]: 'CreditCard',
    [enums_1.PaymentMethod.AmazonPay]: 'AmazonPayRegular',
    [enums_1.PaymentMethod.Sofort]: 'Sofortueberweisung',
    [enums_1.PaymentMethod.StripeKlarna]: 'StripeKlarna',
    [enums_1.PaymentMethod.StripeGooglePay]: 'GooglePayRegular',
    [enums_1.PaymentMethod.StripeApplePay]: 'ApplePayRegular',
};
function trackRegularPaymentMethodSelected(paymentMethod) {
    const eventLabel = checkoutPaymentMethodEventLabelMap[paymentMethod];
    if (eventLabel) {
        (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
            eventCategory: enums_1.EventCategory.Cart,
            eventAction: enums_1.EventAction.SelectPaymentMethod,
            eventLabel,
            eventData: {
                eventName: enums_1.GA4EventName.SelectPaymentMethod,
                feature_category: enums_1.GA4FeatureCategory.Cart,
                payment_method: eventLabel,
            },
        });
    }
}
exports.trackRegularPaymentMethodSelected = trackRegularPaymentMethodSelected;
//# sourceMappingURL=trackRegularPaymentMethodSelected.js.map